export default __webpack_public_path__ + "static/media/Connector_Type2Combo.0af6fab3.svg";